import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Container from './Container';
import Logo from './Logo';
import Button from './Button';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Χαρακτηριστικά', href: '#features' }, // Ενημερώθηκε
    { name: 'Τιμολόγηση', href: '/pricing' },      // Ενημερώθηκε
    { name: 'Συχνές Ερωτήσεις', href: '/faq' },
    { name: 'Επικοινωνία', href: '/contact' }
    // Το "Σχετικά" αφαιρέθηκε
  ];

  return (
    <nav style={{
      backgroundColor: '#1A202C',
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.3)',
      borderBottom: '1px solid #2d3748',
      position: 'sticky',
      top: 0,
      zIndex: 50
    }}>
      {/* CSS fix για να φαίνονται τα στοιχεία σε desktop */}
      <style>{`
        @media (min-width: 768px) {
          .desktop-nav, .desktop-buttons { display: flex !important; }
          .mobile-menu-btn { display: none !important; }
        }
      `}</style>

      <Container>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '4rem'
        }}>
          {/* Logo */}
          <Logo />
          
          {/* Desktop Navigation */}
          <div style={{
            display: 'none',
            alignItems: 'center',
            gap: '2rem'
          }} className="desktop-nav">
            {navLinks.map((link) => (
              link.href.startsWith('/') ? (
                <Link
                  key={link.name}
                  to={link.href}
                  style={{
                    color: '#d1d5db',
                    fontWeight: 500,
                    transition: 'color 0.2s',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#10B981'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = '#d1d5db'; }}
                >
                  {link.name}
                </Link>
              ) : (
                <a
                  key={link.name}
                  href={link.href}
                  style={{
                    color: '#d1d5db',
                    fontWeight: 500,
                    transition: 'color 0.2s',
                    textDecoration: 'none'
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#10B981'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = '#d1d5db'; }}
                >
                  {link.name}
                </a>
              )
            ))}
          </div>

          {/* Desktop Buttons */}
          <div style={{
            display: 'none',
            alignItems: 'center',
            gap: '1rem'
          }} className="desktop-buttons">
            <Link to="/login">
              <Button variant="outline" size="sm">
                Σύνδεση
              </Button>
            </Link>
            <Link to="/signup">
              <Button variant="primary" size="sm">
                Ξεκινήστε Δωρεάν
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            style={{
              display: 'block',
              padding: '0.5rem',
              borderRadius: '0.375rem',
              color: '#d1d5db',
              transition: 'all 0.2s',
              background: 'none',
              border: 'none',
              cursor: 'pointer'
            }}
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg style={{ width: '1.5rem', height: '1.5rem' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <>
            <div style={{
              position: 'fixed',
              top: '4rem',
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              zIndex: 40
            }} onClick={() => setIsMenuOpen(false)} />
            <div style={{
              paddingTop: '1rem',
              paddingBottom: '2rem',
              paddingLeft: '1rem',
              paddingRight: '1rem',
              borderTop: '1px solid #2d3748',
              backgroundColor: '#1A202C',
              position: 'fixed',
              top: '4rem',
              left: 0,
              right: 0,
              bottom: 0,
              overflowY: 'auto',
              zIndex: 50
            }} className="mobile-nav">
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1.25rem'
              }}>
                {navLinks.map((link) => (
                  link.href.startsWith('/') ? (
                    <Link
                      key={link.name}
                      to={link.href}
                      style={{
                        color: '#e5e7eb',
                        fontWeight: 500,
                        transition: 'color 0.2s',
                        textDecoration: 'none',
                        fontSize: '1.1rem'
                      }}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {link.name}
                    </Link>
                  ) : (
                    <a
                      key={link.name}
                      href={link.href}
                      style={{
                        color: '#e5e7eb',
                        fontWeight: 500,
                        transition: 'color 0.2s',
                        textDecoration: 'none',
                        fontSize: '1.1rem'
                      }}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {link.name}
                    </a>
                  )
                ))}
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0.75rem',
                  paddingTop: '1.5rem',
                  borderTop: '1px solid #2d3748'
                }}>
                  <Link to="/login" style={{ textDecoration: 'none' }}>
                    <div style={{
                        padding: '0.75rem',
                        border: '1px solid #2d3748',
                        borderRadius: '0.5rem',
                        color: '#e5e7eb',
                        textAlign: 'center',
                        fontWeight: 600
                    }}>
                      Σύνδεση
                    </div>
                  </Link>
                  <Link to="/signup" style={{ textDecoration: 'none' }}>
                    <Button variant="primary" style={{ width: '100%' }}>
                      Ξεκινήστε Δωρεάν
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </>
        )}
      </Container>
    </nav>
  );
};

export default Navbar;